<template>
  <div
    class="bk-form-overlay-iframe"
    @scroll.stop
    @touchstart.stop.capture.prevent
    @touchmove.stop.capture.prevent
  >
    <iframe ref="iframe" allowtransparency :src="url" @load="onIFrameLoad" />
    <Transition name="bk-loading">
      <Loading v-if="!isLoaded" />
    </Transition>
  </div>
</template>

<script setup>
import { ref, useBlokkli, onUnmounted, onMounted } from "#imports";
import { Loading } from "#blokkli/components";
const { eventBus } = useBlokkli();
const iframe = ref(null);
const isLoaded = ref(false);
const emit = defineEmits(["close"]);
const props = defineProps({
  url: { type: String, required: true },
  form: { type: Object, required: true }
});
function onIFrameLoad() {
  isLoaded.value = true;
  if (iframe.value?.contentWindow) {
    iframe.value.contentWindow?.focus();
  }
}
function onMessage(e) {
  if (!e.data || typeof e.data !== "object") {
    return;
  }
  if (e.data.event !== "BLOKKLI") {
    return;
  }
  const { action } = e.data;
  if (action === "SAVE") {
    if (props.form.id === "entity:edit" || props.form.id === "entity:translate") {
      if (props.form.id === "entity:translate") {
        const langcode = props.form.translation.id;
        eventBus.emit("reloadEntity", () => {
          eventBus.emit("entity:translated", langcode);
        });
      } else {
        eventBus.emit("reloadEntity");
      }
    } else {
      eventBus.emit("reloadState");
    }
    emit("close");
  } else if (action === "CANCEL") {
    emit("close");
  }
}
onMounted(() => {
  window.addEventListener("message", onMessage);
});
onUnmounted(() => {
  window.removeEventListener("message", onMessage);
});
</script>
